import { Skeleton, SkeletonProps } from "@chakra-ui/react";

type Props = Omit<SkeletonProps, "children"> & {
  text?: React.ReactNode;
  minSkeletonWidth?: SkeletonProps["minW"];
  isTextPresenceIgnored?: boolean;
};

export default function SkeletonSingleLineText({
  text,
  isTextPresenceIgnored = false,
  minSkeletonWidth = "10em",
  isLoaded: isLoadedProp = true,
  ...rest
}: Props) {
  const isLoaded = isLoadedProp || (!isTextPresenceIgnored && !!text);
  return (
    <Skeleton
      minW={isLoaded ? undefined : minSkeletonWidth}
      isLoaded={isLoaded}
      {...rest}
    >
      {text || " "}
    </Skeleton>
  );
}
